export enum PolicyChangeRequestType {
  NAME_CHANGE,
  ADDRESS_CHANGE,
  POLICY_COVERAGE_CHANGE,
  MORTGAGE_LENDER_DETAILS_CHANGE,
  DRIVER_LICENSE_CHANGE,
  ADD_POLICY,
  VIN_CHANGE
}
